import {
  FEATURE_FLAGS,
  isFeatureEnabled,
} from '../../../../common/utils/featureFlag'

/** Temporal (MKB-1200): amagar identificació per matrícula/model al catàleg. */
export function isIdentificacionVehiculoEnabled(): boolean {
  return isFeatureEnabled(FEATURE_FLAGS.IDENTIFICACION_VEHICULO)
}
